import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Alert } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface CancelConfirmationDialogProps {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
  hasStartedBaseline: boolean;
}

/**
 * CancelConfirmationDialog - Confirms test cancellation
 * 
 * Shows warning about losing progress and wasting electrode if baseline started
 */
export function CancelConfirmationDialog({
  open,
  onCancel,
  onContinue,
  hasStartedBaseline
}: CancelConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onContinue}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <WarningIcon color="error" sx={{ fontSize: 48 }} />
        </Box>
        <Typography variant="h6" component="div">
          Test cancellation
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body1" textAlign="center" gutterBottom>
          Are you sure you want to cancel the test and start a new one?
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mt: 1 }}>
          Any progress will be lost.
        </Typography>
        
        {hasStartedBaseline && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            ⚠️ Electrode is single-use and will be wasted.
          </Alert>
        )}
      </DialogContent>

      <DialogActions sx={{ flexDirection: 'column', gap: 1, px: 3, pb: 3 }}>
        <Button
          fullWidth
          variant="contained"
          color="error"
          onClick={onCancel}
          sx={{ py: 1.5 }}
        >
          Cancel Test
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onContinue}
          sx={{ py: 1.5 }}
        >
          Continue Test
        </Button>
      </DialogActions>
    </Dialog>
  );
}
